export const ACCOMMODATION_SEARCH_STATE_INIT =
  "ACCOMMODATION_SEARCH_STATE_INIT";
export const ACCOMMODATION_SEARCH_LOAD_STATE =
  "ACCOMMODATION_SEARCH_LOAD_STATE";
export const ACCOMMODATION_SEARCH_PAYLOAD_SAVE =
  "ACCOMMODATION_SEARCH_PAYLOAD_SAVE";
export const ACCOMMODATION_SEARCH_SESSION_LOADING =
  "ACCOMMODATION_SEARCH_SESSION_LOADING";
export const ACCOMMODATION_SEARCH_SESSION_IDLE =
  "ACCOMMODATION_SEARCH_SESSION_IDLE";
export const ACCOMMODATION_SEARCH_STOP = "ACCOMMODATION_SEARCH_STOP";
export const ACCOMMODATION_SEARCH_SET_CURRENT_POLLCOUNT =
  "ACCOMMODATION_SEARCH_SET_CURRENT_POLLCOUNT";
export const ACCOMMODATION_SEARCH_SAVE_META = "ACCOMMODATION_SEARCH_SAVE_META";
export const ACCOMMODATION_SEARCH_SAVE_RESULTS =
  "ACCOMMODATION_SEARCH_SAVE_RESULTS";
export const ACCOMMODATION_SEARCH_FILTERS_CHANGE =
  "ACCOMMODATION_SEARCH_FILTERS_CHANGE";
export const ACCOMMODATION_SEARCH_RESET_FILTER =
  "ACCOMMODATION_SEARCH_RESET_FILTER";

// ================= ACCOMMODATION SEARCH FORM ===================
export const ACCOMMODATION_SYSTEM_INIT = "ACCOMMODATION_SYSTEM_INIT";
export const ACCOMMODATION_SEARCH_FORM_CHANGE =
  "ACCOMMODATION_SEARCH_FORM_CHANGE";
export const ACCOMMODATION_SEARCH_FORM_UPDATE =
  "ACCOMMODATION_SEARCH_FORM_UPDATE";
export const ACCOMMODATION_SEARCH_FORM_RESET =
  "ACCOMMODATION_SEARCH_FORM_RESET";
